export default __webpack_public_path__ + "static/media/loginPhoto.8cb222d3.webp";